import { URLS } from "@app/shared";

export * from "./global-footprint";
export * from "./investment-case";
export * from "./investor-information";
export * from "./investor-resources";
export * from "./key-figures";
export * from "./projects";

export const investorRelations = {
  title: "Investor Relations",
};

export const quickLinks = [
  {
    title: "basicInfo.title",
    href: URLS.investor.basicInfo,
  },
  {
    title: "boardOfDirectors",
    href: URLS.investor.boardOfDirectors,
  },
  {
    title: "sharePerformance.title",
    href: URLS.investor.sharePerformance,
  },
  {
    title: "financialInformation",
    href: URLS.investor.financialInfo,
  },
  {
    title: "governanceAndRegulatoryDocuments.title",
    href: URLS.investor.governanceAndRegulatoryDocuments,
  },
  {
    title: "generalAssembly",
    href: URLS.investor.generalAssembly.root,
  },
  {
    title: "dividendsAndShareholders.title",
    href: URLS.investor.dividendsAndShareholders,
  },
];

export const reports = [
  {
    label: "totalRevenue",
    number: "6.2",
    unit: "bn",
    suffix: null,
    currencyIcon: "sar",
    change: "totalRevenueChange",
    dotColor: "cerulean",
  },
  {
    label: "operatingProfit",
    number: "261",
    unit: "mn",
    suffix: null,
    currencyIcon: "sar",
    change: "operatingProfitChange",
    dotColor: "cerulean",
  },
  {
    label: "netProfit",
    number: "101",
    unit: "mn",
    suffix: null,
    currencyIcon: "sar",
    change: "netProfitChange",
    dotColor: "cerulean",
  },
  {
    label: "earningsPerShare",
    number: "1.68",
    unit: null,
    suffix: "sarPerShare",
    currencyIcon: "sar",
    change: "earningsPerShareChange",
    dotColor: "cerulean",
  },
  {
    label: "grossProfit",
    number: "1.114",
    unit: "bn",
    suffix: null,
    currencyIcon: "sar",
    change: null,
    dotColor: "construction",
  },
  {
    label: "shareholdersEquity",
    number: "694",
    unit: "mn",
    suffix: null,
    currencyIcon: "sar",
    change: null,
    dotColor: "cerulean",
  },
];

export const contactIrCards = [
  {
    title: "contactIrPage.investorRelations",
    items: [
      {
        label: "email",
        value: "investors@senaat.com",
        href: "mailto:investors@senaat.com",
      },
    ],
  },
  {
    title: "contactIrPage.shareholders",
    items: [
      {
        label: "tel",
        value: "+966 13 810 8111",
        href: "tel:+966138108111",
      },
      {
        label: "fax",
        value: "+966 13 810 8199",
        href: "tel:+966138108199",
      },
    ],
  },
];
